import React from 'react';
import ReactDOM from 'react-dom';
import './scss/main.scss';
import "./lib/loaders.min.css";
import App from './App';

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);